var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.name,staticClass:"my-2 caption",attrs:{"href":link.url,"target":"_blank","color":"#C4C4C6","text":"","rounded":""}},[_vm._v(" "+_vm._s(link.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }